/*接口秘钥*/
const interfaces = {
    host:process.env.VUE_APP_INTERFACES_HOST,
}

export{
    interfaces
}
